import { ListGroup } from "react-bootstrap"
import { FaEnvelope, FaSms } from "react-icons/fa"

import NotificationMethod from "../../../api/Notifications/Model/NotificationMethod"

interface NotificationMethodCellProps {
  methods: NotificationMethod[]
}

function NotificationMethodCell({ methods }: NotificationMethodCellProps) {
  const getIconByCode = (code?: string) => {
    switch (code) {
      case "EMAIL":
        return <FaEnvelope title="Enabled notification by Email." data-toggle="tooltip" />
      case "TEXT":
        return <FaSms title="Enabled notification by SMS." data-toggle="tooltip" />
      default:
        return null
    }
  }

  return (
    <>
      {methods?.length > 0 && (
        <ListGroup horizontal>
          {methods.map((x) => (
            <ListGroup.Item key={`${x.Code}-icon-method`} className="bg-transparent text-warning border-0 py-0 px-2">
              {getIconByCode(x.Code)}
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
    </>
  )
}

export default NotificationMethodCell
